import type {
  PermissionAction,
  PermissionCategory,
  PermissionCheckerApi,
  PermissionList,
} from "./types";
import { PermissionAction as PermissionActionEnum } from "./types";
import { DealerUserRole } from "@/gql/graphql";

const isSupportAdminWriteBlocked = (
  role: DealerUserRole | null | undefined,
  action: PermissionAction
): boolean => {
  return (
    role === DealerUserRole.SupportAdmin && action !== PermissionActionEnum.View
  );
};

const PAIR_SEP = "\0";

const buildPermissionLookupKey = (
  category: PermissionCategory,
  action: PermissionAction
): string => `${category}${PAIR_SEP}${action}`;

const collectAllowedPermissions = (
  permissionList: PermissionList
): Set<string> => {
  const allowedPermissions = new Set<string>();
  for (const entry of permissionList) {
    allowedPermissions.add(
      buildPermissionLookupKey(entry.category, entry.action)
    );
  }
  return allowedPermissions;
};

export const buildPermissionChecker = (
  permissionList?: PermissionList | null,
  role?: DealerUserRole | null
): PermissionCheckerApi => {
  const allowedPermissions = collectAllowedPermissions(permissionList ?? []);
  return {
    isSupportAdminWriteBlocked(action: PermissionAction): boolean {
      return isSupportAdminWriteBlocked(role, action);
    },
    hasPermission(
      resource: PermissionCategory,
      action: PermissionAction
    ): boolean {
      return allowedPermissions.has(buildPermissionLookupKey(resource, action));
    },
  };
};
